<script setup>
import { useRouter } from "vue-router";
import { useHead } from "@vueuse/head";

const router = useRouter();

const navigateTo = (path) => {
  router.push(path);
};

// メタ情報と構造化データを設定
useHead({
  title: "SukiSukiアカデミー | SukiSukiらいぶすてーしょん",
  meta: [
    {
      name: "description",
      content:
        "SukiSukiらいぶすてーしょんは、クリエイター・ライバー・VTuberの挑戦を支える配信イベントプラットフォームです。SukiSukiアカデミーでは、主に参加者の皆様向けのノウハウを解説します。",
    },
    {
      property: "og:title",
      content: "SukiSukiアカデミー | SukiSukiらいぶすてーしょん",
    },
    {
      property: "og:description",
      content:
        "SukiSukiらいぶすてーしょんは、クリエイター・ライバー・VTuberの挑戦を支える配信イベントプラットフォームです。SukiSukiアカデミーでは、主に参加者の皆様向けのノウハウを解説します。",
    },
    {
      property: "og:type",
      content: "website",
    },
  ],
});
</script>

<template>
  <v-app>
    <v-container>
      <v-row class="text-start">
        <v-col cols="12" class="text-center">
          <h2 class="mt-2">SukiSukiアカデミー</h2>
        </v-col>
        <v-col cols="12" class="dics">
          <p>
            SukiSukiらいぶすてーしょんは、クリエイター・ライバー・VTuberの挑戦を支える配信イベントプラットフォーム。<br /><br />
            日常ではなく、特別なイベントのために開かれる場所です。<br /><br />
            配信を通じてクラファンやリアルタイムくじ引きを行い、ファンと共に“挑戦の瞬間“を盛り上げます。<br /><br />
            SukiSukiアカデミーでは、主に参加者の皆様向けのノウハウを解説します。
          </p>
        </v-col>
      </v-row>
      <v-row>
        <button class="actual-screen-button">配信クラファン</button>
      </v-row>
      <v-row>
        <v-col
          @click="navigateTo('/academy/about-haishin-crowdfunding')"
          cols="12"
          class="article-section-box"
        >
          <div class="article-section">
            <img src="/img/airticlepic/article1.webp" alt="配信クラファン" />
            <p>配信クラファンとは？概要・メリットをわかりやすく解説</p>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          @click="navigateTo('/academy/how-to-start-crowdfunding-for-vtubers')"
          cols="12"
          class="article-section-box"
        >
          <div class="article-section">
            <img src="/img/airticlepic/article2.webp" alt="配信クラファン" />
            <p>
              VTuber・ライバーのクラファンの始め方-クラウドファンディングの始め方をわかりやすく解説
            </p>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          @click="navigateTo('/academy/vtuber-crowdfunding')"
          cols="12"
          class="article-section-box"
        >
          <div class="article-section">
            <img src="/img/airticlepic/article3.webp" alt="配信クラファン" />
            <p>VTuberクラファンとは？仕組み・費用・事例・始め方をわかりやすく解説</p>
          </div>
        </v-col>
      </v-row>

      <!-- CTA ボタン -->
      <div class="cta-section">
        <v-container>
          <v-btn @click="navigateTo('/crowdfundinginvite')" class="cta-button" block large>
            「配信クラファン」詳細/資料請求/無料相談はこちら
          </v-btn>
        </v-container>
      </div>
      <!-- <v-row>
        <v-col @click="navigateTo('/academyarticle1')" cols="12" class="article-section-box">
          <div class="article-section">
            <img src="/img/airticlepic/article1.webp" alt="配信クラファン" />
            <p>配信クラファンとは？概要・メリットをわかりやすく解説</p>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          @click="navigateTo('/academy/about-haishin-crowdfunding')"
          cols="12"
          class="article-section-box"
        >
          <div class="article-section">
            <img src="/img/airticlepic/article1.webp" alt="配信クラファン" />
            <p>配信クラファンとは？概要・メリットをわかりやすく解説</p>
          </div>
        </v-col>
      </v-row> -->

      <v-row>
        <button class="actual-screen-button">リアルタイムくじ引き</button>
      </v-row>
      <v-row>
        <v-col
          @click="navigateTo('/academy/about-realtime-kujibiki')"
          cols="12"
          class="article-section-box"
        >
          <div class="article-section">
            <img src="/img/airticlepic/articlerealtime1.webp" alt="リアルタイムくじ引き" />
            <p>リアルタイムくじ引きとは？概要・メリット・従来のオンラインくじとの違いを解説</p>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          @click="navigateTo('/academy/realtime-kujibiki-guide-2025')"
          cols="12"
          class="article-section-box"
        >
          <div class="article-section">
            <img src="/img/airticlepic/articlerealtime2.webp" alt="リアルタイムくじ引き" />
            <p>
              VTuber向けグッズ販売の完全ガイド｜作り方・費用・売れる仕組み・売り方まで徹底解説（2025年版）
            </p>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          @click="navigateTo('/academy/kujibiki-interview-ugichamipaisen')"
          cols="12"
          class="article-section-box"
        >
          <div class="article-section">
            <img src="/img/airticlepic/ugichamipaisen_intervie_top.webp" alt="リアルタイムくじ引き" />
            <p>
              【VTuberインタビュー】リアルタイムくじ引きを体験したうぎちゃみパイセンさんに聞く！配信企画の裏側と感想
            </p>
          </div>
        </v-col>

      </v-row>
      <!-- CTA ボタン -->
      <div class="cta-section">
        <v-container>
          <v-btn
            @click="navigateTo('/documentinvite')"
            class="cta-button cta-button-shita"
            block
            large
          >
            「リアルタイムくじ引き」詳細/資料請求/無料相談はこちら
          </v-btn>
        </v-container>
      </div>
    </v-container>
  </v-app>
</template>

<style scoped>
.custom-content {
  line-height: 1.4; /* これにより行の高さが増加します */
}
.dics {
  font-size: 14px;
  line-height: 1.3;
  /* text-align: left; */
  padding: 30px;
}
.actual-screen-button {
  background: #ffe3f2;
  color: #982da6;
  border: 3px solid #982da6;
  border-radius: 15px;
  font-size: 1rem;
  font-weight: bold;
  transition: all 0.3s ease;
  display: block;
  box-shadow: 3px 3px 0 #da3990;
  padding: 0.8rem 2rem;
  width: auto;
  margin: 20px auto 1.5rem auto;
  cursor: default;
}
.article-section-box {
  padding: 30px;
  padding-top: 10px;
  cursor: pointer;
}
.article-section {
  width: 100%;
  height: auto;
  display: block;
}
.article-section img {
  width: 100%;
  height: auto;
  display: block;
}
.article-section p {
  text-align: left;
  margin-top: 10px;
  font-weight: bold;
  line-height: 1.3;
}
/* CTA ボタン */
.cta-section {
  padding-bottom: 40px;
}
.cta-button {
  background: #da3990;
  color: white !important;
  font-size: 12px;
  font-weight: bold;
  height: 60px;
}
.cta-button-shita {
  font-size: 11px;
}
.cta-button-shita {
  background: #982da6;
}
@media (min-width: 750px) {
  .actual-screen-button {
    background: #ffe3f2;
    color: #982da6;
    border: 3px solid #982da6;
    border-radius: 15px;
    font-size: 20px;
    font-weight: bold;
    transition: all 0.3s ease;
    display: block;
    box-shadow: 3px 3px 0 #da3990;
    padding: 0.8rem 2rem;
    width: auto;
    margin: 20px auto 1.5rem auto;
    cursor: default;
  }

  .article-section-box {
    padding-left: 25%;
    padding-right: 25%;
  }
  .dics {
    padding-left: 25%;
    padding-right: 25%;
  }
  .cta-section {
    margin-left: 23%;
    margin-right: 23%;
  }
  .cta-button {
    font-size: 14px;
  }
}
</style>
